import React, {useMemo} from 'react'
import SortableTable, {ColumnConfig} from '../SortableTable'
import HighlightText from '../HighlightText'
import {useHistory} from 'react-router-dom'
import {useSelector} from 'react-redux'
import Routes from '../../constants/RouteConstants'
import {CATEGORY_USER_TYPE} from './SettingsConstants'
import {PERMISSION_GROUP_FORMER_USER, PERMISSION_GROUP_GLOBAL_ADMIN} from '../../constants/ModelConstants'
import {isGlobalAdminUserType} from '../../Utils/globalAdminUtils'

const DashboardUsersTable = function (props) {
  const history = useHistory()
  const activeOrganization = useSelector(state => state.GlobalAdmin.organizationsLookup[state.GlobalAdmin.activeOrganizationId])
  const columns = useMemo(() => [
    new ColumnConfig({
      title: 'Staff Name',
      renderPrimitive: g => (g.id ? g.displayName : ''),
      render: (g, col) => (g.id ? <HighlightText search={props.filterTerm}>{col.renderPrimitive(g)}</HighlightText> : null),
      comparator: ColumnConfig.simpleComparatorGenerator('displayName'),
      isDefaultSort: true,
    }),

    new ColumnConfig({
      title: 'User Type',
      renderPrimitive: g => {
        if (isGlobalAdminUserType(activeOrganization, g)) {
          return CATEGORY_USER_TYPE[PERMISSION_GROUP_GLOBAL_ADMIN]
        }
        return g.isDisabled
          ? CATEGORY_USER_TYPE[PERMISSION_GROUP_FORMER_USER]
          : g.permissionGroup
          ? CATEGORY_USER_TYPE[g.permissionGroup]
          : 'N/A'
      },
      render: (g, col) => (g.id ? <HighlightText search={props.filterTerm}>{col.renderPrimitive(g)}</HighlightText> : null),
      comparator: ColumnConfig.simpleComparatorGenerator('permissionGroup', undefined, group => CATEGORY_USER_TYPE[group]),
    }),
  ], [activeOrganization, props.filterTerm])

  return (
    <SortableTable
      data={props.users}
      columns={columns}
      downloadFileName={`Users`}
      onClickRow={r => history.push(Routes.constructPath(Routes.SETTINGS_DASHBOARD_USERS_VIEW_SINGLE, {userId: r.id}))}
    />
  )
}

export default DashboardUsersTable
